import { CookieService } from 'ngx-cookie-service';
import { CoreCompanyApiService } from '@app/modules/auth'; // , CoreUserApiService
import { AuthService } from '@auth0/auth0-angular';

// solution from https://www.tektutorialshub.com/angular/angular-providers/#factory-provider-usefactory
export const zonarUiAnalyticsFactory = (
  cookieSvc: CookieService,
  coreCompanyApiSvc: CoreCompanyApiService,
  // coreUserSvc: CoreUserApiService,
  authSvc: AuthService
) => {
  //  if EU, or some other region we don't use Google Tag Manager, just return an empty object so GTM does not get instantiated
  return {};
};
